module.exports = __webpack_public_path__ + "assets/img/gxl.e068a646.jpg";